import * as TextureEditNodes from "@app/textures/texture-editor/texture-edit-nodes"

export enum LayerEditMode {
    Move = "move",
    Draw = "draw",
}

export enum LayerMoveMode {
    ImageAndMask = "image-and-mask",
    ImageOnly = "image-only",
    MaskOnly = "mask-only",
}

export type BlendMode = Exclude<TextureEditNodes.OperatorLayerAndMask["blendMode"], undefined>
